import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { AccountDetailPage } from './AccountDetailPage';

const searchSchema = z.object({
  edit: z.string().optional(),
});

export const Route = createFileRoute('/_protected/_consumer/account/$accountId/')({
  component: AccountDetailPage,
  validateSearch: searchSchema,
});
